module.exports = __webpack_public_path__ + "assets/pdf/E03-cn-tibetan-plateau-vortices.44f2e099.pdf";